import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { Loader2 } from 'lucide-react';

/**
 * This component handles the OneDrive OAuth callback when it accidentally
 * lands on the frontend instead of the backend.
 * It extracts the code and state, then redirects to the backend callback.
 */
const OneDriveCallbackHandler = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('Procesando autenticación de OneDrive...');
  const [error, setError] = useState(null);

  useEffect(() => {
    const handleCallback = async () => {
      const code = searchParams.get('code');
      const state = searchParams.get('state');
      const errorParam = searchParams.get('error');
      const errorDescription = searchParams.get('error_description');

      console.log('OneDrive callback received on frontend:', { 
        hasCode: !!code, 
        hasState: !!state, 
        error: errorParam 
      });

      // If there's an error from Microsoft
      if (errorParam) {
        setError(`Error de Microsoft: ${errorDescription || errorParam}`);
        setTimeout(() => navigate('/backup?error=' + encodeURIComponent(errorParam)), 3000);
        return;
      }

      // If we have code and state, redirect to backend
      if (code && state) {
        setStatus('Redirigiendo al servidor...');
        
        // Get the backend URL
        const backendUrl = process.env.REACT_APP_BACKEND_URL || 
          (window.location.hostname === 'cminventario.com' 
            ? 'https://api.cminventario.com'
            : '');
        
        // Construct the backend callback URL
        const callbackUrl = `${backendUrl}/api/backup/onedrive/callback?code=${encodeURIComponent(code)}&state=${encodeURIComponent(state)}`;
        
        console.log('Redirecting to backend callback:', callbackUrl);
        
        // Redirect to backend callback
        window.location.href = callbackUrl;
      } else {
        setError('Parámetros de callback incompletos');
        setTimeout(() => navigate('/backup?error=missing_params'), 3000);
      }
    };

    handleCallback();
  }, [searchParams, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="text-center p-8 max-w-md">
        {error ? (
          <>
            <div className="text-red-500 text-xl mb-4">⚠️</div>
            <h2 className="text-xl font-semibold text-red-500 mb-2">Error</h2>
            <p className="text-muted-foreground">{error}</p>
            <p className="text-sm text-muted-foreground mt-4">Redirigiendo a Backup...</p>
          </>
        ) : (
          <>
            <Loader2 className="h-12 w-12 animate-spin mx-auto mb-4 text-primary" />
            <h2 className="text-xl font-semibold mb-2">Conectando OneDrive</h2>
            <p className="text-muted-foreground">{status}</p>
          </>
        )}
      </div>
    </div>
  );
};

export default OneDriveCallbackHandler;
